//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headers from '../../components/headers'

export default {
    components: {
        headers,
    },
    data () {
        return {
          model:{},
         bannerModel:[],
         ArtModel:[],
         shareModel:[],
         show:false,
          message:"",
          shareTitleName:"",
        //   shareList:"",
        }
    },
     created(){
        this.getIndexBanner();//轮播图
        this.getPageUrlList()//培训认证
        this.getShareList()//知识分享
    },
    methods: {
        open(url){
          if(url==null||url==""){
            return;
          }
          window.location.href=url;
        },
        showalert(){
               alert("请移步至PC端操作");
        },
        getIndexBanner(){
                    this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getIndexBanner?type=3',this.model,{emulateJSON:true}).then(function(res){
                    
                            if(res.body.success)
                            {
                            this.bannerModel= res.body.data
                            }    
                        },function(res){
                    });
                },
        getPageUrlList(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getPageUrlList?pageId=3&devPageAreaId=1',this.model,{emulateJSON:true}).then(function(res){
              
                    if(res.body.success)
                    {
                      this.ArtModel= res.body.data                     
                    }    
                },function(res){
            });
         },
         getShareList(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getPageUrlList?pageId=3&devPageAreaId=2',this.model,{emulateJSON:true}).then(function(res){
             
                    if(res.body.success)
                    {
                    //   this.shareModel= res.body.data
                      this.shareModel=res.body.shareList
                      this.shareTitleName=res.body.shareTitleName
                    }    
                },function(res){
            });
         },             
          goUrl(Url){
              if(this.isLogin()==false){
                    alert("请先登录")
                    this.$router.push({path:'/auth/login'})
                }else{
                   window.location.href = Url
                }
            
        },
        returnTop:function(id){
            document.querySelector("#"+id).scrollIntoView(true);
        },
        goList:function() {
            window.location.href = "/consult/sharelist?typeId=4&typeName="+this.shareTitleName
        },
        goShareDetail:function (newsId,newsType) {
             window.location.href = "/consult/shareDetail?typeId="+newsType+"&newsId="+newsId+"&typeName="+this.shareTitleName
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/newdeveloper/developerIndex.vue